import { hasAccessTo } from "layouts/Config";
import strings from "./StringConstants";

export const billingListHeader = () => {
  return [
    {
      name: "Invoice Number",
      field: "invoiceNumber",
      align: "left",
      // sorting: true,
    },
    {
      name: "Plan",
      field: "planName",
      align: "center",
      // sorting: true,
    },
    {
      name: "Start Date",
      field: "startDate",
      align: "center",
      // sorting: true,
    },
    {
      name: "End Date",
      field: "endDate",
      align: "center",
      // sorting: true,
    },
    {
      name: "Status",
      field: "paymentStatus",
      align: "center",
      // sorting: true,
    },
    ...(hasAccessTo(strings.downloadPermission, strings.resources.billing)
      ? [
          {
            name: "Action",
            field: "action",
            align: "center",
          },
        ]
      : []),
  ];
};

export const planTableHeader = [
  {
    name: "Name",
    field: "name",
    align: "left",
  },
  {
    name: "Phone",
    field: "contactNo",
    align: "left",
  },
  {
    name: "Email",
    field: "email",
    align: "left",
  },
  {
    name: "Role",
    field: "role",
    align: "left",
  },
  {
    name: "Status",
    field: "status",
    align: "left",
  },
  {
    name: "Action",
    field: "action",
    align: "left",
    hide: true,
  },

  //   {
  //     name: "Manager's Email",
  //     field: "managedBy",
  //     align: "left",
  //   },
  //   {
  //     name: "Email Count",
  //     field: "allowedEmailCount",
  //     align: "left",
  //   },
  //   {
  //     name: "Used Email",
  //     field: "emailCount",
  //     align: "left",
  //   },
];

export const paymentMethodsTableHeader = [
  {
    name: "Card Number",
    field: "number",
    align: "left",
    sorting: false,
  },
  {
    name: "Delete",
    field: "delete",
    align: "right",
    sorting: false,
    hide: true,
  },
];

export const cardNetworks = {
  visa: "visa",
  mastercard: "mastercard",
  americanExpress: "amex",
  discover: "discover",
  dinersClub: "diners",
  jcb: "jcb",
  ChinaUnionPay: "unionpay",
  cartesBancaires: "cartes_bancaires",
};

export const signerFieldValidationPatterns = {
  Numbers: /^[\d\s\r\n]+$/,
  Letters: /^[a-zA-Z\s\r\n]+$/,
  SSN: /^\d{3}-\d{2}-\d{4}$/,
  Zip: /^\d{5}$/,
  "Zip+4": /^\d{5}-\d{4}$/,
  none: /.*/, // Match anything for 'none'
};

export const certificateDataFormat = [
  {
    label: strings.selfsigned,
    leftCount: 0,
    usedCount: 0,
    used: strings.used,
    left: strings.left,
  },
  {
    label: strings.notariusverified,
    leftCount: 0,
    usedCount: 0,
    used: strings.used,
    left: strings.left,
  },
];